import { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useBlockCardStore } from '@lib/store';
import type { GetAllCardsResponse } from '@shared/api';
import { Button, Error, Modal, Radio } from '@shared/widgets';

interface IForm {
  type: string;
}

interface IBlockUnblockModalProps {
  card: GetAllCardsResponse;
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
}

export const BlockUnblockModal = (props: IBlockUnblockModalProps) => {
  const { loading, error, success, block, resetError, clear } = useBlockCardStore();

  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm<IForm>({ defaultValues: { type: 'Block' } });

  useEffect(() => {
    if (loading) return;
    if (error) {
      setError('root', { message: 'Something went wrong. Please try again or contact customer service.' });
      return;
    }
    if (success) {
      clear();
      props.onClose();
      props.onConfirm?.();
    }
  }, [loading, error, success]);

  const closeHandler = () => {
    resetError();
    props.onClose();
  };
  const blockUnblockHandler = (data: IForm) => block(data, props.card.id);

  return (
    <Modal title='Block/Unblock' isOpen={props.isOpen} onClose={closeHandler}>
      <form onSubmit={handleSubmit(blockUnblockHandler)}>
        <div className='text-ld max-md:mt-0 max-md:w-auto max-md:font-[Prata]'>
          <p className='max-md:inherit hidden max-md:mb-8 max-md:text-[#4c4c4c80]'>Here you may temporarily or permanently block your card</p>
          <div className='font-medium max-md:rounded-[10px] max-md:bg-[#d7c29a10] max-md:p-[10px] max-md:font-[Prata] max-md:text-lg'>
            <span className='hidden max-md:mb-2 max-md:block'>Your Card</span>
            XXXX XXXX XXXX {props.card?.cardNumber?.slice(props.card?.cardNumber?.length - 4, props.card?.cardNumber?.length)}
          </div>
          <div className='mt-12 flex flex-col gap-2 max-md:gap-0 max-md:border-t max-md:border-[#4c4c4c10] max-md:p-0'>
            <Controller
              name='type'
              control={control}
              render={({ field }) => (
                <>
                  <Radio
                    className='max-md:border-b max-md:border-b-[#4c4c4c10] max-md:py-4'
                    name={field.name}
                    checked={field.value === 'Block'}
                    value='Block'
                    onChange={() => field.onChange('Block')}
                  >
                    Block
                  </Radio>
                  <Radio
                    className='max-md:border-b max-md:border-b-[#4c4c4c10] max-md:py-4'
                    name={field.name}
                    checked={field.value === 'Unblock'}
                    value='Unblock'
                    onChange={() => field.onChange('Unblock')}
                  >
                    Unblock
                  </Radio>
                </>
              )}
            />
          </div>
        </div>
        {errors.root?.message && <Error className='mt-6' text={errors.root.message} />}
        <Button className='mx-auto mt-8 w-[303px] max-md:w-full' type='submit' isLoading={loading}>
          Submit
        </Button>
      </form>
    </Modal>
  );
};
